<script lang="ts">
  import { Meta } from '../components';
</script>

<Meta title="Home" />
<div class="overview">
  <h3>You are now logged in.</h3>
  <img src="/logo.svg" alt="logo" />
</div>
